import { render } from "./WCBreadcrumb.vue?vue&type=template&id=19e0e20c&scoped=true"
import script from "./WCBreadcrumb.vue?vue&type=script&lang=js"
export * from "./WCBreadcrumb.vue?vue&type=script&lang=js"

import "./WCBreadcrumb.vue?vue&type=style&index=0&id=19e0e20c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19e0e20c"]])

export default __exports__